import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '.';
import { CustomError } from 'src/lib/error';
import { eventBus } from 'src/core/event-bus';
import { getCannyToken as fetchToken } from 'src/services/canny/canny.service';
import logger from 'src/logger';
import { openUrl } from 'src/utils/url.util';

type TInitialState = {
  token?: string;
  expiry?: number | null;
};

const CANNY_PAGE_URL = 'https://feedback.neo.space/feature-requests';
const initialState: TInitialState = {};

const cannySlice = createSlice({
  name: 'cannySlice',
  initialState,
  reducers: {
    reset: state => {
      state.token = undefined;
      state.expiry = undefined;
    },
  },
  extraReducers: builder => {
    builder.addCase(fetchAndRedirectToCanny.fulfilled, (state, action) => {
      state.token = action.payload;
      const now = new Date();
      now.setHours(now.getHours() + 24);
      state.expiry = now.getTime();
    });
  },
});

const { reset } = cannySlice.actions;

export { reset };

export const fetchAndRedirectToCanny = createAsyncThunk('get/cannyToken', async (_, { getState, dispatch }) => {
  const {
    session,
    canny: { token, expiry },
  } = getState() as RootState;
  try {
    if (!session) throw new CustomError({ errorCode: 'SessionNotFound' });
    const Token = await new Promise((resolve, reject) => {
      if (token && expiry && expiry > Date.now()) {
        return resolve(token);
      }
      dispatch(reset());
      return fetchToken().then(resolve).catch(reject);
    });
    openUrl(CANNY_PAGE_URL + '?ssoToken=' + Token, '_blank');
    return token;
  } catch (err) {
    logger.reportError(err, { message: 'Error in fetchAndRedirectToCanny' });
    eventBus.emit('error/showToast', err);
  }
});

export const cannyTokenSelector = (state: RootState) => state.canny;

export default cannySlice.reducer;
